// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { Chapter, CompletionStatusType, ModuleType, Note, Progress } from '../../types/Model';
import LabContent from './components/LabContent';
import ChallengeContent from './components/ChallengeContent';
import ExamContent from './components/ExamContent';
import HyperlinkContent from './components/HyperlinkContent';
import TextContent from './components/TextContent';
import { useCurrentModule, useVodId, useLabId, useChallengeId, useExamId, useHyperlinkId, useCurrentSubtitle, useCourseType, useChapterModuleId, useSendActive, useAssessmentId } from './hooks';
import { S } from './styles';
import EpilogueContent from './components/EpilogueContent';
import ReactPlayer from 'react-player';
import { OnProgressEvent, PlayerHandle } from '../Player/Player';
import { useAlert } from 'react-alert';
import { VideoSnackbarContext } from '../../AppRouter';
import { SnackbarAccept } from './components/VideoSnackbar/styles';
import ErrorPage from '../../pages/ErrorPage';
import LoadingIcon from '../LoadingIcon';
import AssessmentContent from './components/AssessmentContent';
import { sampleChapter } from './data';

interface VodCache {
  courseId: number;
  vodId: number;
  playedSeconds: number;
}

function getVodsCache() {
  return JSON.parse(localStorage.getItem('vods') || '[]') as VodCache[]
}

function setVodsCache(vodsCache: VodCache[]) {
  localStorage.setItem('vods', JSON.stringify(vodsCache));
}

function getVodCache(courseId: number, vodId: number) {
  const vodsCache = getVodsCache();
  return vodsCache.find(cache => cache.courseId === courseId && cache.vodId === vodId);
}

function updateVodCache(vodCache: VodCache) {
  const vodsCache = getVodsCache();
  const hitCache = vodsCache.find((cache) =>
    cache.courseId === vodCache.courseId && cache.vodId === vodCache.vodId
  )

  if (hitCache) {
    hitCache.playedSeconds = vodCache.playedSeconds;
  } else {
    vodsCache.push(vodCache);
  }

  setVodsCache(vodsCache);
}

function removeVodCache(courseId: number, vodId: number) {
  const vodsCache = getVodsCache();
  setVodsCache(vodsCache.filter(cache =>
    !(cache.courseId === courseId && cache.vodId === vodId))
  )
}

interface CourseContentProps {
  chapters: Chapter[];
  chaptersIsFetching: boolean;
  notes?: Note[];
  isNoteFetching?: boolean;
  noteError?: Error;
  name: string;
  /** Online course id or workshop id  */
  courseId: number;
  progress: Progress[];
  handleUpdateProgress: (progress: Progress) => void;
  handleCreateNote?: (vodId: number, time: number, message: string) => void;
  handleDeleteNote?: (noteId: string) => void;
  handleUpdateNote?: (noteId: string, message: string) => void;
  handleFetchNote?: () => void;
}

const AUTO_NEXT_TIMEOUT = 5000;

export enum CourseType {
  Workshop = 'workshop',
  OnlineCourse = 'onlineCourse'
}

interface CacheData {
  courseId: number;
  vodId: number;
  playedSeconds: number;
}

const CourseContent: React.FC<CourseContentProps> = (props): JSX.Element => {
  const {
    chapters,
    notes,
    name,
    courseId,
    progress,
    chaptersIsFetching,
    handleUpdateProgress,
    handleCreateNote,
    handleDeleteNote,
    handleUpdateNote,
    handleFetchNote,
    isNoteFetching,
    noteError,
  } = props;
  // const chapters = sampleChapter;
  const [currentTime, setCurrentTime] = useState<number>(0);
  const currentModule = useCurrentModule(chapters);
  const vodId = useVodId(currentModule);
  const labId = useLabId(currentModule);
  const challengeId = useChallengeId(currentModule);
  const examId = useExamId(currentModule);
  const hyperlinkId = useHyperlinkId(currentModule);
  const assessmentId = useAssessmentId(currentModule);
  const currentVideoSubtitles = useCurrentSubtitle(currentModule);
  const history = useHistory();
  const location = useLocation();
  const courseType = useCourseType();
  const [chapterId, moduleId] = useChapterModuleId();

  const [isAutoNext, setIsAutoNext] = useState(false);
  const [isEpilogueShow, setIsEpilogueShow] = useState(false);
  const [needRewatch, setNeedRewatch] = useState<boolean>(false);
  const [isAlertShowed, setIsAlertShowed] = useState(false);
  const [isCache, setIsCache] = useState<CacheData>();
  const alert = useAlert(VideoSnackbarContext);
  const playerRef = React.useRef<PlayerHandle>(null);

  const sendActive = useSendActive();

  useEffect(() => {
    const found = getVodCache(courseId, vodId);
    setIsCache(found)
  }, [location])

  // Initial state
  useEffect(() => {
    setIsEpilogueShow(false);
    setIsAlertShowed(false);
    setNeedRewatch(false);
    setIsAutoNext(false);
  }, [location]);

  // Auto next
  useEffect(() => {
    if (isAutoNext) {
      const timeout = setTimeout(() => {
        redirectToNextModule();
        setIsAutoNext(false);
      }, AUTO_NEXT_TIMEOUT);

      return () => clearTimeout(timeout);
    }
  }, [isAutoNext]);

  function handleAutoNextResponse(isAccepted: boolean) {
    if (isAccepted) {
      redirectToNextModule();
    }

    setIsAutoNext(false);
  }

  function handleAutoNextStart() {
    removeVodCache(courseId, vodId);

    setIsAutoNext(true);

    if (
      currentModule?.type === ModuleType.VIDEO &&
      currentModule?.status === CompletionStatusType.INCOMPLETE
    ) {
      handleUpdateProgress({ vodId });
    }
  }

  /**
   * @returns [chapterId, moduleId]
   */
  function getFirstIncompleteChapterModuleId(): [number, number] {
    for (const chapter of chapters) {
      for (const module of chapter.modules) {
        if (!progress.find(progress => (
          (module.type === ModuleType.VIDEO && 'vodId' in progress && progress.vodId === module.vodId) ||
          (module.type === ModuleType.LAB && 'labId' in progress && progress.labId === module.labId) ||
          (module.type === ModuleType.CHALLENGE && 'challengeId' in progress && progress.challengeId === module.challengeId) ||
          (module.type === ModuleType.EXAM && 'examId' in progress && progress.examId === module.examId) ||
          (module.type === ModuleType.QUIZ && 'quizId' in progress && progress.quizId === module.quizId) ||
          (module.type === ModuleType.HYPERLINK && 'hyperlinkId' in progress && progress.hyperlinkId === module.hyperlinkId) ||
          (module.type === ModuleType.ASSESSMENT && 'assessmentId' in progress && progress.assessmentId === module.assessmentId)
        ))) {
          return [chapters.indexOf(chapter) + 1, chapter.modules.indexOf(module) + 1];
        }
      }
    }
    return [chapterId, moduleId]; // return the same chapterId & moduleId as currently on last module
  }

  /**
   * @returns [chapterId, moduleId]
   */
  function getNextChapterModuleId(): [number, number] {
    const isChapterFinished = chapters[chapterId - 1].modules.length === moduleId;
    const isLastChapter = chapters.length === chapterId;

    if (isChapterFinished) {
      if (isLastChapter) {
        return [chapterId, moduleId]; // return the same chapterId & moduleId as currently on last module
      } else {
        return [chapterId + 1, 1];
      }
    } else {
      return [chapterId, moduleId + 1]
    }
  }

  function redirectToNextModule() {
    const [nextChapterId, nextModuleId] = getNextChapterModuleId();
    if (nextChapterId === chapterId && nextModuleId === moduleId) {
      const [incompleteChapterId, incompleteModuleId] = getFirstIncompleteChapterModuleId();
      if (incompleteChapterId === chapterId && incompleteModuleId === moduleId) { // course completed
        setIsEpilogueShow(true);
      } else if (isEpilogueShow) { // redirect to incomplete course
        setNeedRewatch(false);
        history.push(`/${courseType}/${courseId}/contents?chapter=${incompleteChapterId}&module=${incompleteModuleId}`);
      } else { // course incomplete
        setNeedRewatch(true);
        setIsEpilogueShow(true);
      }
    } else {
      history.push(`/${courseType}/${courseId}/contents?chapter=${nextChapterId}&module=${nextModuleId}`);
    }
  }

  // Progress
  function handleProgress(ref: ReactPlayer | null, event: OnProgressEvent) {
    const { playedSeconds } = event;
    setCurrentTime(playedSeconds);

    function handleSeekToLastWatch() {
      if (isCache && ref) {
        ref.seekTo(isCache.playedSeconds, 'seconds');
      }
    }

    if (!isAutoNext) {
      updateVodCache({
        courseId,
        vodId,
        playedSeconds
      })

      if (!isAlertShowed) {
        if (isCache) {
          alert.show(
            (<SnackbarAccept onClick={handleSeekToLastWatch}><FormattedMessage id="F004" /></SnackbarAccept>),
            { onOpen: () => setIsAlertShowed(true) }
          );
        }
      } else {
        setIsAlertShowed(true);
      }
    }
  }

  function handleUpdateProgressLab() {
    if (
      currentModule?.type === ModuleType.LAB &&
      currentModule?.status === CompletionStatusType.INCOMPLETE
    ) {
      handleUpdateProgress({ labId });
    }
  }

  function handleUpdateProgressChallenge() {
    if (
      currentModule?.type === ModuleType.CHALLENGE &&
      currentModule?.status === CompletionStatusType.INCOMPLETE
    ) {
      handleUpdateProgress({ challengeId });
    }
  }

  function handleUpdateProgressExam() {
    if (
      currentModule?.type === ModuleType.EXAM &&
      currentModule?.status === CompletionStatusType.INCOMPLETE
    ) {
      handleUpdateProgress({ examId });
    }
  }

  function handleUpdateProgressHyperlink() {
    if (
      currentModule?.type === ModuleType.HYPERLINK &&
      currentModule?.status === CompletionStatusType.INCOMPLETE
    ) {
      handleUpdateProgress({ hyperlinkId: hyperlinkId ? hyperlinkId : 'null' });
    }
  }

  function handleUpdateProgressAssessment(newScore: number) {
    if (
      currentModule?.type === ModuleType.ASSESSMENT &&
      (currentModule?.score || 0) <= newScore
    ) {
      handleUpdateProgress({ assessmentId, score: newScore });
    }
  }

  function renderModule() {
    if (isEpilogueShow) {
      return <EpilogueContent needRewatch={needRewatch} handleNextModule={redirectToNextModule} />
    }

    switch (currentModule?.type) {
      case ModuleType.VIDEO:
        return (
          <S.VideoContainer>
            <S.Player
              ref={playerRef}
              urls={currentModule.videoUrls?.hlsGroup}
              subtitles={currentVideoSubtitles}
              isAutoNext={isAutoNext}
              onAutoNextStart={handleAutoNextStart}
              onAutoNextResponse={handleAutoNextResponse}
              onProgress={handleProgress}
              onSendActive={sendActive}
              vodId={vodId}
              sourceFrom={courseType}
              sourceId={courseId}
            />
          </S.VideoContainer>
        )
      case ModuleType.LAB:
        return (
          <LabContent
            id={labId}
            triggerProgress={handleUpdateProgressLab}
            status={currentModule.status}
            handleNextModule={redirectToNextModule}
            courseId={courseId}
            courseType={courseType}
          />
        )
      case ModuleType.CHALLENGE:
        return (
          <ChallengeContent
            id={challengeId}
            triggerProgress={handleUpdateProgressChallenge}
            status={currentModule.status}
            handleNextModule={redirectToNextModule}
            courseId={courseId}
            courseType={courseType}
          />
        )
      case ModuleType.EXAM:
        return (
          <ExamContent
            id={examId}
            triggerProgress={handleUpdateProgressExam}
            status={currentModule.status}
            handleNextModule={redirectToNextModule}
            courseId={courseId}
            courseType={courseType}
          />
        )
      case ModuleType.HYPERLINK:
        return (
          <HyperlinkContent
            data={currentModule}
            triggerProgress={handleUpdateProgressHyperlink}
            status={currentModule.status}
            handleNextModule={redirectToNextModule}
          />
        )
      case ModuleType.TEXT:
        return (
          <TextContent
            data={currentModule}
            status={currentModule.status}
            handleNextModule={redirectToNextModule}
          />
        )
      case ModuleType.QUIZ:
        return <>TODO</>
      case ModuleType.ASSESSMENT:
        return (
          <AssessmentContent
            data={currentModule}
            triggerProgress={handleUpdateProgressAssessment}
            status={currentModule.status}
            handleNextModule={redirectToNextModule}
          />
        )
      default:
        return (
          <S.VideoContainer>
            <ErrorPage />
          </S.VideoContainer>
        );
    }
  }

  return (
    <S.Container>
      {renderModule()}
      <S.Sidebar
        courseId={courseId}
        name={name}
        chapters={chapters}
        chaptersIsFetching={chaptersIsFetching}
        notes={notes}
        isNoteFetching={isNoteFetching}
        noteError={noteError}
        handleCreateNote={(message) => handleCreateNote && handleCreateNote(vodId, currentTime, message)}
        handleDeleteNote={handleDeleteNote}
        handleUpdateNote={handleUpdateNote}
        handleFetchNote={handleFetchNote}
        handleSeek={playerRef.current?.handleSeek}
        setPlaying={playerRef.current?.setPlaying}
        courseType={courseType}
      />
    </S.Container>
  );
}

export { CourseContent as default };
